const GetEntityInfo = async (entity, id) => {
    const response = await fetch("/api/" + entity + "/" + id);

    if (response.status !== 200) {
        throw new Error("response status is not 200");
    }

    return response.json();
};

export default GetEntityInfo;
